<template>
	<div class="component-index">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="title">
			<template v-if="!$vuetify.breakpoint.xs && switchIndex" v-slot:app-bar-btn>
				<v-btn color="primary" dark @click="back()"><i class="fas fa-undo"></i>検索へ戻る</v-btn>
			</template>
			<template v-if="switchIndex == false">
				<v-card elevation="0">
					<v-form class="pa-2" ref="form" lazy-validation>
						<div>
							※　期間で検索した場合、指定月の前月の棚卸しデータ・指定月の入出庫データのみ表示されます。
							<br />
							※　製品に対しての割り当てを行う場合は、案件や整番も入力してください
						</div>
						<v-radio-group v-model="form" row class="mt-3" mandatory>
							<v-radio
								label="部品を検索"
								value="component_form"
								@click="switchComponentForm()"
							></v-radio>
							<v-radio
								label="製品を検索"
								value="product_form"
								@click="switchProductForm()"
							></v-radio>
						</v-radio-group>
						<v-menu
							ref="menu"
							v-model="menu"
							:close-on-content-click="false"
							transition="scale-transition"
							offset-y
							max-width="290px"
							min-width="auto"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									outlined
									dense
									v-model="month"
									label="年月で検索"
									readonly
									v-bind="attrs"
									v-on="on"
									@click="menu = true"
								/>
							</template>
							<v-date-picker
								v-model="month"
								type="month"
								no-title
								scrollable
								locale="ja"
								@input="menu = false"
							>
							</v-date-picker>
						</v-menu>
						<div v-if="form == 'component_form'">
							<v-text-field
								v-model="name"
								label="部品名で検索"
								hint="部品名を入力してください"
								class="mt-4"
								outlined
								dense
							/>
							<v-text-field
								v-model="part_number"
								label="部品品番で検索"
								hint="品番を入力してください"
								class="mt-4"
								outlined
								dense
							/>
						</div>
						<div v-if="form == 'product_form'">
							<v-text-field
								v-model="name"
								label="製品名で検索"
								hint="製品名を入力してください"
								class="mt-4"
								outlined
								dense
							/>
						</div>
						<v-combobox
							ref="combobox"
							:items="ordered_products"
							item-text="get_processed_product_number"
							item-value="id"
							v-model="ordered_product"
							label="製造番号で検索"
							dense
							outlined
							class="mt-4"
							:hint="
								productNumberKeyword.length > 0 ? '選択してください' : '製造番号を入力してください'
							"
							@keyup="setSearchProductNumber"
							@change="changeOrderedProduct"
							small-chips
							single
						/>
						<v-text-field
							label="案件で検索"
							dense
							outlined
							:rules="[rules.moreThanThree]"
							class="mt-4"
							hint="案件の見積番号・受注番号・製造番号を入力してください。"
							v-model="searchWord"
							@keyup="searchMatters()"
						/>
						<v-row v-if="searchedMatters" align="center" justify="space-around">
							<v-btn
								height="auto"
								class="ma-2 pa-2"
								depressed
								v-for="matter in searchedMatters"
								:key="matter.id"
								@click="setMatter(matter)"
							>
								<div class="text-left">
									<p v-if="matter.name">{{ matter.name }}</p>
									<p v-if="matter.quotation_number">
										{{ "見積番号:" + matter.quotation_number }}
										{{ "-" + matter.quotation_sub_number }}
									</p>
									<p v-if="matter.order_number">
										{{ matter.order_number ? "受注番号:" + matter.order_number : "" }}
									</p>
									<div v-if="matter.order_number">
										<p v-for="(op, index) in matter.ordered_products" :key="'op-' + op.id">
											製番{{ index + 1 }}:{{ op.product_number }}
										</p>
									</div>
								</div>
							</v-btn>
						</v-row>
						<v-card class="mx-auto my-2" v-for="(matter, index) in selectedMatter" :key="matter.id">
							<v-card-text>
								<v-flex class="justify-space-between">
									<div>
										<p>案件名：{{ matter.name }}</p>
										<p>見積番号：{{ matter.quotation_number }}-{{ matter.quotation_sub_number }}</p>
										<p>受注番号：{{ matter.order_number }}</p>
										<p>得意先：{{ matter.regular_customer_company.name }}</p>
										<p>向け先：{{ matter.customer_company.name }}</p>
										<p v-if="matter.contract">
											製番：
											<span
												class="d-inline-block mx-1"
												v-for="op in matter.ordered_products"
												:key="op.id"
												>{{ op.product_number }}</span
											>
										</p>
									</div>
									<v-icon @click="removeMatter(index)">mdi-close</v-icon>
								</v-flex>
							</v-card-text>
						</v-card>
					</v-form>
					<v-card-actions>
						<v-row no-gutters class="pb-2">
							<v-col cols="4">
								<v-row no-gutters justify="start">
									<v-btn color="grey darken-1" text @click="resetForm()"> リセット </v-btn>
								</v-row>
							</v-col>
							<v-col cols="4">
								<v-row no-gutters justify="center">
									<v-btn
										color="secondary"
										@click="searchComponentStock(1)"
										v-if="form == 'component_form'"
									>
										<v-icon class="mr-1">mdi-magnify</v-icon>
										検索する
									</v-btn>
									<v-btn
										color="secondary"
										@click="searchProductStock(1)"
										v-if="form == 'product_form'"
									>
										<v-icon class="mr-1">mdi-magnify</v-icon>
										検索する
									</v-btn>
								</v-row>
							</v-col>
						</v-row>
					</v-card-actions>
				</v-card>
			</template>

			<template v-if="switchIndex && form == 'component_form'">
				<span class="attention" v-if="$vuetify.breakpoint.xs"
					>※在庫一覧表はPCもしくはタブレットで使用してください
				</span>
				<div class="targetinfo"></div>
				<div class="month">表示月：{{ currentMonth | monthFormatter }}</div>
				<v-container>
					<v-row no-gutters class="my-1"><p class="text-h6">検索内容</p></v-row>
					<v-row no-gutters class="my-1">
						<v-col cols="6" sm="4" v-if="name">
							<v-card outlined
								><v-card-subtitle>部品名</v-card-subtitle><v-divider class="mx-3"></v-divider
								><v-card-title v-if="name">{{ name }} を含む</v-card-title>
							</v-card>
						</v-col>
						<v-col cols="6" sm="4" v-if="part_number">
							<v-card outlined
								><v-card-subtitle>品番</v-card-subtitle><v-divider class="mx-3"></v-divider
								><v-card-title v-if="part_number">{{ part_number }} を含む</v-card-title>
							</v-card>
						</v-col>
						<v-col cols="12" sm="4" v-if="ordered_product">
							<v-card outlined
								><v-card-subtitle>製造番号</v-card-subtitle><v-divider class="mx-3"></v-divider
								><v-card-title v-if="ordered_product"
									><p class="pre-wrap" v-text="ordered_product.get_processed_product_number"></p
								></v-card-title>
							</v-card>
						</v-col>
						<v-col cols="12" sm="4" v-if="selectedMatter[0]">
							<v-card outlined
								><v-card-subtitle>案件に含まれる全ての製品の部品</v-card-subtitle
								><v-divider class="mx-3"></v-divider
								><v-card-title v-if="selectedMatter[0]"
									><p class="pre-wrap" v-text="common.returnMatterInfo(selectedMatter[0])"></p
								></v-card-title>
							</v-card>
						</v-col>
					</v-row>
				</v-container>
				<div class="d-flex">
					<v-checkbox v-model="fixed" class="mt-3 ml-2" label="見出し列を固定"></v-checkbox>
					<v-spacer></v-spacer>
					<v-btn color="calendar-btn" class="mr-2" @click="componentPreviousMonth()">
						<v-icon>mdi-chevron-left</v-icon>先月</v-btn
					>
					<v-btn color="calendar-btn" class="mr-2" @click="componentNextMonth()"
						>翌月<v-icon>mdi-chevron-right</v-icon></v-btn
					>
				</div>
				<div class="table">
					<table>
						<tr class="top">
							<th :class="['main-color', { 'sticky-01': fixed, 'not-sticky-01': !fixed }]">
								部品品番
							</th>
							<th :class="['main-color', { 'sticky-02': fixed, 'not-sticky-02': !fixed }]">
								部品名
							</th>
							<th :class="['main-color', { 'sticky-03': fixed, 'not-sticky-03': !fixed }]">
								先月繰越
							</th>
							<th :class="['main-color', { 'sticky-04': fixed, 'not-sticky-04': !fixed }]">
								月末在庫見込数
							</th>
							<th :class="['main-color', { 'sticky-05': fixed, 'not-sticky-05': !fixed }]">合計</th>
							<th :class="['main-color', { 'sticky-06': fixed, 'not-sticky-06': !fixed }]">
								入出庫
							</th>
							<th v-for="date in scheduleDates" :key="date.id">
								{{ date | dateFormatter }}
							</th>
						</tr>
						<tbody v-for="component in components" :key="component.id">
							<tr>
								<td rowspan="2" :class="{ 'sticky-01': fixed, 'not-sticky-01': !fixed }">
									{{ component.part_number }}
								</td>
								<td rowspan="2" :class="{ 'sticky-02': fixed, 'not-sticky-02': !fixed }">
									{{ component.name }}
								</td>
								<td rowspan="2" :class="{ 'sticky-03': fixed, 'not-sticky-03': !fixed }">
									{{ componentCarryOver(component.id) }}
								</td>
								<td
									rowspan="2"
									:class="{
										'negative-number': componentTotalQuantity(component.id) < 0,
										'sticky-04': fixed,
										'not-sticky-04': !fixed,
									}"
								>
									{{ componentTotalQuantity(component.id) }}
								</td>
								<td
									:class="{
										'sticky-05': fixed,
										'not-sticky-05': !fixed,
									}"
								>
									{{ componentTotalShippings(component.id) }}
								</td>
								<td
									:class="{
										'sticky-06': fixed,
										'not-sticky-06': !fixed,
									}"
								>
									出庫
								</td>
								<td
									class="pointer"
									v-for="date in scheduleDates"
									:key="date.id"
									@click="openComponentShippingShowDialog(component, date, receiving_shippings)"
								>
									<span :class="{ future_number: date >= today }">
										{{ componentShippingQuantity(date, component.id) }}
									</span>
								</td>
							</tr>
							<tr>
								<td :class="{ 'sticky-05': fixed }">
									{{ componentTotalReceivings(component.id) }}
								</td>
								<td :class="{ 'sticky-06': fixed }">入庫</td>
								<td
									class="pointer"
									v-for="date in scheduleDates"
									:key="date.id"
									@click="openComponentReceivingShowDialog(component, date, receiving_shippings)"
								>
									<span
										:class="{
											future_number: date >= today,
											unreceived:
												componentReceivingQuantity(date, component.id).notReceived && date < today,
										}"
									>
										{{ componentReceivingQuantity(date, component.id).quantity }}
									</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<PaginationModule
					:pagination="pagination"
					@get-page="getComponentPage($event)"
				></PaginationModule>
			</template>
			<template v-if="switchIndex && form == 'product_form'">
				<div class="month">表示月：{{ currentMonth | monthFormatter }}</div>
				<v-container>
					<v-row no-gutters class="my-1"><p class="text-h6">検索内容</p></v-row>
					<v-row no-gutters class="my-1">
						<v-col cols="6" sm="4" v-if="name">
							<v-card outlined
								><v-card-subtitle>製品名</v-card-subtitle><v-divider class="mx-3"></v-divider
								><v-card-title v-if="name">{{ name }} を含む</v-card-title>
							</v-card>
						</v-col>
						<v-col cols="6" sm="4" v-if="part_number">
							<v-card outlined
								><v-card-subtitle>品番</v-card-subtitle><v-divider class="mx-3"></v-divider
								><v-card-title v-if="part_number">{{ part_number }} を含む</v-card-title>
							</v-card>
						</v-col>
						<v-col cols="12" sm="4" v-if="ordered_product">
							<v-card outlined
								><v-card-subtitle>製造番号</v-card-subtitle><v-divider class="mx-3"></v-divider
								><v-card-title v-if="ordered_product"
									><p class="pre-wrap" v-text="ordered_product.get_processed_product_number"></p
								></v-card-title>
							</v-card>
						</v-col>
						<v-col cols="12" sm="4" v-if="selectedMatter[0]">
							<v-card outlined
								><v-card-subtitle>案件に含まれる全ての製品</v-card-subtitle
								><v-divider class="mx-3"></v-divider
								><v-card-title v-if="selectedMatter[0]"
									><p class="pre-wrap" v-text="common.returnMatterInfo(selectedMatter[0])"></p
								></v-card-title>
							</v-card>
						</v-col>
					</v-row>
				</v-container>

				<div class="d-flex">
					<v-checkbox v-model="fixed" class="mt-3 ml-2" label="見出し列を固定"></v-checkbox>
					<v-spacer></v-spacer>
					<v-btn color="calendar-btn" class="mr-2" @click="productPreviousMonth()">
						<v-icon>mdi-chevron-left</v-icon>先月</v-btn
					>
					<v-btn color="calendar-btn" class="mr-2" @click="productNextMonth()"
						>翌月<v-icon>mdi-chevron-right</v-icon></v-btn
					>
				</div>
				<div class="table">
					<table>
						<tr class="top">
							<th :class="['main-color', { 'sticky-01': fixed, 'not-sticky-01': !fixed }]">
								品目コード
							</th>
							<th :class="['main-color', { 'sticky-02': fixed, 'not-sticky-02': !fixed }]">
								製品名
							</th>
							<th :class="['main-color', { 'sticky-03': fixed, 'not-sticky-03': !fixed }]">
								先月繰越
							</th>
							<th :class="['main-color', { 'sticky-04': fixed, 'not-sticky-04': !fixed }]">
								在庫(予定含む)
							</th>
							<th :class="['main-color', { 'sticky-05': fixed, 'not-sticky-05': !fixed }]">合計</th>
							<th :class="['main-color', { 'sticky-06': fixed, 'not-sticky-06': !fixed }]">
								入出庫
							</th>
							<th v-for="date in scheduleDates" :key="date.id">
								{{ date | dateFormatter }}
							</th>
						</tr>
						<tbody v-for="product in products" :key="product.id">
							{{product}}
							<tr>
								<td rowspan="2" :class="{ 'sticky-01': fixed, 'not-sticky-01': !fixed }">
									{{ product.product_code }}
								</td>
								<td rowspan="2" :class="{ 'sticky-02': fixed, 'not-sticky-02': !fixed }">
									{{ product.name }}
								</td>
								<td rowspan="2" :class="{ 'sticky-03': fixed, 'not-sticky-03': !fixed }">
									{{ productCarryOver(product.id) }}
								</td>
								<td
									rowspan="2"
									:class="{
										'negative-number': productTotalQuantity(product.id) < 0,
										'sticky-04': fixed,
										'not-sticky-04': !fixed,
									}"
								>
									{{ productTotalQuantity(product.id) }}
								</td>
								<td
									:class="{
										'sticky-05': fixed,
										'not-sticky-05': !fixed,
									}"
								>
									{{ productTotalShippings(product.id) }}
								</td>
								<td
									:class="{
										'sticky-06': fixed,
										'not-sticky-06': !fixed,
									}"
								>
									出庫
								</td>
								<td
									class="pointer"
									@click="openProductShippingShowDialog(product, date, receiving_shippings)"
									v-for="date in scheduleDates"
									:key="date.id"
								>
									<span :class="{ future_number: date >= today }">
										{{ productShippingQuantity(date, product.id) }}
									</span>
								</td>
							</tr>
							<tr>
								<td :class="{ 'sticky-05': fixed }">{{ productTotalReceivings(product.id) }}</td>
								<td :class="{ 'sticky-06': fixed }">入庫</td>
								<td
									class="pointer"
									v-for="date in scheduleDates"
									:key="date.id"
									@click="openProductReceivingShowDialog(product, date, receiving_shippings)"
								>
									<span
										:class="{
											future_number: date >= today,
											unreceived:
												productReceivingQuantity(date, product.id).notReceived && date < today,
										}"
									>
										{{ productReceivingQuantity(date, product.id).quantity }}
									</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<PaginationModule
					:pagination="pagination"
					@get-page="getProductPage($event)"
				></PaginationModule>
			</template>
		</CommonFlame>
		<ComponentShippingShowDialog
			v-if="form == 'component_form'"
			ref="component_shipping"
			:authorityFlag="authority_flag"
			@reload-index="receiving_shippings.push($event)"
			@reload-delete-index="getDeletedIndex"
		/>
		<ComponentReceivingShowDialog
			v-if="form == 'component_form'"
			ref="component_receiving"
			:authorityFlag="authority_flag"
			@reload-new-index="receiving_shippings.push($event)"
			@reload-delete-index="getDeletedIndex"
		/>
		<ProductShippingShowDialog
			v-if="form == 'product_form'"
			ref="product_shipping"
			:authorityFlag="authority_flag"
			@reload-new-index="receiving_shippings.push($event)"
			@reload-delete-index="getDeletedIndex"
		/>
		<ProductReceivingShowDialog
			v-if="form == 'product_form'"
			ref="product_receiving"
			:authorityFlag="authority_flag"
			@reload-new-index="receiving_shippings.push($event)"
			@reload-delete-index="getDeletedIndex"
		/>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import moment from "moment"
import "moment/locale/ja"
import errorHandling from "../../helper/errorHandling"
import PaginationModule from "../../modules/PaginationModule.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import rules from "../../helper/rules"
import common from "../../helper/common"
import ComponentShippingShowDialog from "./components/ComponentShippingShowDialog.vue"
import ComponentReceivingShowDialog from "./components/ComponentReceivingShowDialog.vue"
import ProductShippingShowDialog from "./components/ProductShippingShowDialog.vue"
import ProductReceivingShowDialog from "./components/ProductReceivingShowDialog.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
		ComponentShippingShowDialog,
		ComponentReceivingShowDialog,
		ProductShippingShowDialog,
		ProductReceivingShowDialog,
	},
	filters: {
		dateFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("MM/DD(dd)")
		},
		monthFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY年MM月")
		},
	},
	data() {
		return {
			common: common,
			title: "在庫一覧検索",
			mainTitle: "",
			rules: rules,
			q: {
				name_cont: "",
				part_number_cont: "",
			},
			name: "",
			part_number: "",
			product_number: "",
			month: "",
			ordered_product: "",
			ordered_products: [],
			menu: false,
			date: "",
			searchWord: "",
			searchedMatters: [],
			selectedMatter: [],
			switchIndex: false,
			components: [],
			products: [],
			receiving_shippings: [],
			carry_overs: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			scheduleDates: [],
			currentMonth: [],
			form: "",
			searchProductNumberTimer: "",
			productNumberKeyword: "",
			today: "",
			fixed: false,
			authority_flag: false,
		}
	},
	mounted() {
		this.getMonthTitle()
		this.getCurrentMonth()
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
		if (
			this.$route.query.name_cont ||
			this.$route.query.month ||
			this.$route.query.part_number_cont ||
			this.$route.query.order_components_product_matter_products_matter_id_eq_any ||
			this.$route.query.order_components_product_ordered_products_id_eq_any
		) {
			this.name = this.$route.query.name_cont
			this.part_number = this.$route.query.part_number_cont
			this.month = this.$route.query.month

			if (this.$route.query.form_type != "product_form") {
				const ordered_product_id =
					this.$route.query.order_components_product_ordered_products_id_eq_any
				const matter_ids =
					this.$route.query.order_components_product_matter_products_matter_id_eq_any
				this.searchComponentStock(page, ordered_product_id, matter_ids)
			} else {
				const ordered_product_id = this.$route.query.ordered_products_id_eq_any
				const matter_ids = this.$route.query.matter_products_matter_id_eq_any
				this.searchProductStock(page, ordered_product_id, matter_ids)
			}
		}
		// this.searchProductStock(page, ordered_product_id, matter_ids)

		const moment = require("moment")
		this.today = moment().format("YYYY-MM-DD")
	},
	methods: {
		switchComponentForm() {
			this.$router.push({
				name: "stocks",
				query: { form_type: "component_form" },
			})
		},
		switchProductForm() {
			this.$router.push({
				name: "stocks",
				query: { form_type: "product_form" },
			})
		},
		setQuery() {
			const query = this.$route.query
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					this.q[query_key] = this.formatQuery(query[query_key])
				}
			})
		},

		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},

		back() {
			this.switchIndex = false
			this.month = moment(this.month).format("YYYY-MM")

			this.title = "在庫一覧検索"
		},
		getMonthTitle() {
			let now = new Date()
			this.currentMonth = now
		},

		feachTargetMonth(target_month) {
			let search_month = new Date(target_month)
			this.currentMonth = search_month

			let schedules = []
			let daysInMonth = moment(target_month).daysInMonth()
			let month = moment(target_month).month() + 1
			let year = moment(target_month).year()
			for (let i = 1; i <= daysInMonth; i++) {
				schedules.push(moment(`${year}-${month}-${i}`).format("YYYY-MM-DD"))
			}
			this.scheduleDates = schedules
		},
		setMatter(matter) {
			this.searchedMatters = []
			this.selectedMatter.push(matter)
		},
		removeMatter(index) {
			this.selectedMatter.splice(index, 1)
		},
		resetForm() {
			this.$refs.form.reset()
			this.$router.push({ query: null })
			this.ordered_product = ""
			this.searchedMatters = []
			this.selectedMatter = []
		},
		searchMatters() {
			if (this.searchWord.length > 1) {
				this.searchedMatters = []
				const headers = authenticate.setHeader()
				axios
					.get("/erp/v1/matter_search.json", {
						headers,
						params: {
							q: { quotation_number_or_order_number_cont: this.searchWord },
							qq: { product_number_cont: this.searchWord },
						},
					})
					.then((response) => {
						this.searchedMatters = response.data.matters
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			} else {
				this.searchedMatters = []
			}
		},

		changeOrderedProduct() {
			// テキスト追加時の削除
			if (!this.ordered_products.includes(this.ordered_product)) {
				this.ordered_product = null
				this.receiving_shippings = null
				this.$refs.combobox.reset()
			}
		},

		setSearchProductNumber(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.ordered_products = []
			this.productNumberKeyword = e.target.value
			clearTimeout(this.searchProductNumberTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.productNumberKeyword.length) return // 0文字の場合はreturn
			this.searchProductNumberTimer = setTimeout(this.fetchProductNumbers, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
		},
		fetchProductNumbers() {
			const params = {
				q: {
					product_number_cont: this.productNumberKeyword,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/search_ordered_products", {
					headers,
					params,
				})
				.then((res) => {
					this.searchProductNumberTimer = null
					this.ordered_products = res.data.ordered_products
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		openComponentShippingShowDialog(component, date, receiving_shippings) {
			const shipping_quantity = this.componentShippingQuantity(date, component.id)
			const total_quantity = this.componentTotalQuantity(component.id)
			this.$refs.component_shipping.openDialog(
				component,
				date,
				total_quantity,
				shipping_quantity,
				receiving_shippings
			)
		},
		openComponentReceivingShowDialog(component, date, receiving_shippings) {
			this.$refs.component_receiving.openDialog(component, date, receiving_shippings)
		},
		openProductShippingShowDialog(product, date, receiving_shippings) {
			const shipping_quantity = this.productShippingQuantity(date, product.id)
			const total_quantity = this.productTotalQuantity(product.id)
			this.$refs.product_shipping.openDialog(
				product,
				date,
				total_quantity,
				shipping_quantity,
				receiving_shippings
			)
		},
		openProductReceivingShowDialog(product, date, receiving_shippings) {
			this.$refs.product_receiving.openDialog(product, date, receiving_shippings)
		},

		getComponentPage(page) {
			this.searchComponentStock(page)
		},

		getProductPage(page) {
			this.searchProductStock(page)
		},

		getCurrentMonth() {
			let schedules = []
			const daysInMonth = moment(this.currentMonth).daysInMonth()
			const month = moment(this.currentMonth).month() + 1
			const year = moment(this.currentMonth).year()
			for (let i = 1; i <= daysInMonth; i++) {
				schedules.push(moment(`${year}-${month}-${i}`).format("YYYY-MM-DD"))
			}
			this.scheduleDates = schedules
		},
		componentNextMonth() {
			const matter_ids = this.$route.query.order_components_product_matter_products_matter_id_eq_any
			const ordered_product_id =
				this.$route.query.order_components_product_ordered_products_id_eq_any

			this.currentMonth = moment(this.currentMonth).add(1, "month").format("YYYY-MM-DD")
			this.$router.push({
				name: "stocks",
				query: { month: this.currentMonth },
			})
			this.getCurrentMonth()
			this.month = moment(this.currentMonth).format("YYYY-MM")
			this.searchComponentStock(this.pagination.current, ordered_product_id, matter_ids)
		},
		componentPreviousMonth() {
			const matter_ids = this.$route.query.order_components_product_matter_products_matter_id_eq_any
			const ordered_product_id =
				this.$route.query.order_components_product_ordered_products_id_eq_any
			this.currentMonth = moment(this.currentMonth).add(-1, "month").format("YYYY-MM-DD")
			this.$router.push({
				name: "stocks",
				query: { month: this.currentMonth },
			})
			this.getCurrentMonth()
			this.month = moment(this.currentMonth).format("YYYY-MM")
			this.searchComponentStock(this.pagination.current, ordered_product_id, matter_ids)
		},

		productNextMonth() {
			const matter_ids = this.$route.query.matter_products_matter_id_eq_any
			const ordered_product_id = this.$route.query.ordered_products_id_eq_any

			this.currentMonth = moment(this.currentMonth).add(1, "month").format("YYYY-MM-DD")
			this.$router.push({
				name: "stocks",
				query: { month: this.currentMonth },
			})
			this.getCurrentMonth()
			this.month = moment(this.currentMonth).format("YYYY-MM")
			this.searchProductStock(this.pagination.current, ordered_product_id, matter_ids)
		},
		productPreviousMonth() {
			const matter_ids = this.$route.query.matter_products_matter_id_eq_any
			const ordered_product_id = this.$route.query.ordered_products_id_eq_any

			this.currentMonth = moment(this.currentMonth).add(-1, "month").format("YYYY-MM-DD")
			this.$router.push({
				name: "stocks",
				query: { month: this.currentMonth },
			})
			this.getCurrentMonth()
			this.month = moment(this.currentMonth).format("YYYY-MM")
			this.searchProductStock(this.pagination.current, ordered_product_id, matter_ids)
		},

		searchComponentStock(page, ordered_product_id, matter_ids) {
			this.title = "部品在庫一覧"
			authenticate.authenticateUser()
			this.switchIndex = true
			const headers = authenticate.setHeader()
			if (this.month) {
				console.log(this.month);
				this.feachTargetMonth(this.month)
			}

			if (matter_ids) {
				var matterIds = matter_ids
			} else {
				var matterIds = this.selectedMatter.map((matter) => matter.id)
				console.log(this.selectedMatter)
			}

			if (ordered_product_id == undefined) {
				var orderedProductId = this.ordered_product.id
			} else {
				var orderedProductId = ordered_product_id
			}

			const params = {
				name_cont: this.name,
			}

			const date_params = this.currentMonth
			axios
				.get(`/erp/v1/search_stocks`, {
					headers,
					params: { q: params, page: page, date_params },
				})
				.then((res) => {
					this.components = res.data.components
					this.products = res.data.products
					this.receiving_shippings = res.data.receiving_shippings
					this.carry_overs = res.data.carry_overs
					this.pagination = res.data.pagination
					this.authority_flag = res.data.authority_flag
					this.form = "component_form"

					this.$router.push({
						name: "stocks",
						query: { ...params, form_type: this.form, month: date_params, page: page },
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		searchProductStock(page, ordered_product_id, matter_ids) {
			this.title = "製品在庫一覧"
			authenticate.authenticateUser()
			const headers = authenticate.setHeader()
			this.switchIndex = true
			if (this.month) {
				this.feachTargetMonth(this.month)
			}

			if (matter_ids) {
				var matterIds = matter_ids
			} else {
				var matterIds = this.selectedMatter.map((matter) => matter.id)
			}

			if (ordered_product_id == undefined) {
				var orderedProductId = this.ordered_product.id
			} else {
				var orderedProductId = ordered_product_id
			}

			const params = {
				name_cont: this.name,
				matter_products_matter_id_eq_any: matterIds,
				ordered_products_id_eq_any: orderedProductId,
			}
			const date_params = this.currentMonth

			axios
				.get(`/erp/v1/search_product_stocks`, {
					headers,
					params: { q: params, page: page, date_params },
				})
				.then((res) => {
					this.products = res.data.products
					this.receiving_shippings = res.data.receiving_shippings
					this.carry_overs = res.data.carry_overs
					this.pagination = res.data.pagination
					this.authority_flag = res.data.authority_flag
					this.form = "product_form"

					this.$router.push({
						name: "stocks",
						query: { ...params, form_type: this.form, month: date_params, page: page },
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		componentCarryOver(component_id) {
			const array = this.carry_overs.filter(function (value) {
				return value.target_id == component_id
			})
			const total_quantity = array.reduce(function (sum, element) {
				return sum + element.quantity
			}, 0)
			return total_quantity
		},
		productCarryOver(product_id) {
			const array = this.carry_overs.filter(function (value) {
				return value.target_id == product_id
			})
			const total_quantity = array.reduce(function (sum, element) {
				return sum + element.quantity
			}, 0)
			return total_quantity
		},
		componentShippingQuantity(date, component_id) {
			const array = this.receiving_shippings.filter(function (value) {
				return (
					value.operation_date == date &&
					value.target_id == component_id &&
					value.movement_type == "shipping"
				)
			})
			const total_quantity = array.reduce(function (sum, element) {
				return sum + element.planned_quantity
			}, 0)

			if (total_quantity == 0) {
				return ""
			} else {
				return total_quantity
			}
		},
		componentReceivingQuantity(date, component_id) {
			const array = this.receiving_shippings.filter(function (value) {
				return (
					value.operation_date == date &&
					value.target_id == component_id &&
					value.movement_type == "receiving"
				)
			})
			const total_quantity = array.reduce(function (sum, element) {
				return sum + element.planned_quantity
			}, 0)
			const unreceived = array.some(function (value) {
				return value.received_status == "unreceived"
			})
			if (total_quantity == 0) {
				return ""
			} else {
				return { quantity: total_quantity, notReceived: unreceived }
			}
		},
		productShippingQuantity(date, product_id) {
			const array = this.receiving_shippings.filter(function (value) {
				return (
					value.operation_date == date &&
					value.target_id == product_id &&
					value.movement_type == "shipping"
				)
			})
			const total_quantity = array.reduce(function (sum, element) {
				return sum + element.planned_quantity
			}, 0)
			if (total_quantity == 0) {
				return ""
			} else {
				return total_quantity
			}
		},
		productReceivingQuantity(date, product_id) {
			const array = this.receiving_shippings.filter(function (value) {
				return (
					value.operation_date == date &&
					value.target_id == product_id &&
					value.movement_type == "receiving"
				)
			})
			const unreceived = array.some(function (value) {
				return value.received_status == "unreceived"
			})
			const total_quantity = array.reduce(function (sum, element) {
				return sum + element.planned_quantity
			}, 0)
			if (total_quantity == 0) {
				return ""
			} else {
				return { quantity: total_quantity, notReceived: unreceived }
			}
		},
		componentTotalShippings(component_id) {
			const array = this.receiving_shippings.filter(function (value) {
				return value.target_id == component_id && value.movement_type == "shipping"
			})
			const total_quantity = array.reduce(function (sum, element) {
				return sum + element.planned_quantity
			}, 0)

			return total_quantity
		},

		componentTotalReceivings(component_id) {
			const array = this.receiving_shippings.filter(function (value) {
				return value.target_id == component_id && value.movement_type == "receiving"
			})
			const total_quantity = array.reduce(function (sum, element) {
				return sum + element.planned_quantity
			}, 0)
			return total_quantity
		},

		productTotalShippings(product_id) {
			const array = this.receiving_shippings.filter(function (value) {
				return value.target_id == product_id && value.movement_type == "shipping"
			})
			const total_quantity = array.reduce(function (sum, element) {
				return sum + element.planned_quantity
			}, 0)
			return total_quantity
		},

		productTotalReceivings(product_id) {
			const array = this.receiving_shippings.filter(function (value) {
				return value.target_id == product_id && value.movement_type == "receiving"
			})
			const total_quantity = array.reduce(function (sum, element) {
				return sum + element.planned_quantity
			}, 0)
			return total_quantity
		},

		componentTotalQuantity(component_id) {
			return (
				this.componentCarryOver(component_id) -
				this.componentTotalShippings(component_id) +
				this.componentTotalReceivings(component_id)
			)
		},
		productTotalQuantity(product_id) {
			return (
				this.productCarryOver(product_id) -
				this.productTotalShippings(product_id) +
				this.productTotalReceivings(product_id)
			)
		},
		getDeletedIndex(receiving_shipping_id) {
			this.receiving_shippings = this.receiving_shippings.filter(
				(v) => v.id !== receiving_shipping_id
			)
		},
	},
	computed: {},
}
</script>
<style scoped lang="scss">
@import "../../stylesheet/variable.scss";

table {
	border-collapse: separate;
	text-align: center;
	max-height: 1000px;
}
th,
td {
	border: 1px gray solid;
	padding: 3px;
	font-weight: bold;
}
th {
	background-color: $sub-color;
	color: #fff;
	min-width: 110px;
	text-align: center;
	position: sticky;
	top: 0;
}

.pointer {
	cursor: pointer;
}
i {
	margin-right: 5px;
}

.d-flex {
	height: 50px;
	margin-top: 8px;
}

.sticky-01 {
	position: sticky;
	left: 0px;
	z-index: 2;
	min-width: 230px;
}

.sticky-02 {
	position: sticky;
	left: 230px;
	z-index: 2;
	min-width: 230px;
}

.sticky-03 {
	position: sticky;
	left: 460px;
	z-index: 2;
	min-width: 100px;
}
.sticky-04 {
	position: sticky;
	left: 560px;
	z-index: 2;
	min-width: 100px;
}

.negative-number {
	color: red;
}
.future_number {
	color: #8d99e0;
}
.sticky-05 {
	position: sticky;
	left: 660px;
	z-index: 2;
	min-width: 100px;
}

.sticky-06 {
	position: sticky;
	left: 760px;
	z-index: 2;
	min-width: 100px;
}

.not-sticky-01 {
	z-index: 2;
	min-width: 230px;
}

.not-sticky-02 {
	z-index: 2;
	min-width: 230px;
}

.not-sticky-03 {
	z-index: 2;
	min-width: 100px;
}
.not-sticky-04 {
	z-index: 2;
	min-width: 100px;
}

.not-sticky-05 {
	z-index: 2;
	min-width: 100px;
}

.not-sticky-06 {
	z-index: 2;
	min-width: 100px;
}
.main-color {
	background-color: $main-color;
	position: sticky;
	top: 0;
	z-index: 3;
}
.table {
	height: 590px;
	overflow-y: scroll;
}
.month {
	font-size: 25px;
	font-weight: bold;
	margin-left: 7px;
}

tr:nth-child(even) {
	background: #e0ffff;
}

.unreceived {
	color: red;
}
</style>
